<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <kt-portlet-header
    title="Sales Teams List"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div *ngIf="!fromDoctor && !fromFacility">
        <button
          mat-raised-button
          matTooltip="New Sales Call"
          color="primary"
          type="button"
          (click)="createNewSalesTeam()"
        >
          <span class="svg-icon-md">
            <i class="ki ki-calendar-2" style="color: white"></i>
            New Sales Team</span
          >
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->
    <div class="form kt-margin-b-30">
      <!-- start::FILTERS -->
      <div class="form-filtration">
        <div class="row align-items-center">
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
              <input matInput placeholder="{{ 'TABLE.SEARCH' | translate }}" #searchInput />
              <button
                *ngIf="searchInput.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchInput.value = ''; paginator.pageIndex = 0; loadSalesTeamsList()"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-hint align="start">
                <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
                {{ 'TABLE.IN_ALL_FIELDS' | translate }}
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Type</mat-label>
              <mat-select
                [(value)]="typeFilter"
                (selectionChange)="paginator.firstPage(); loadSalesTeamsList()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="FIELD_SALES">Field Sales</mat-option>
                <mat-option value="INSIDE_SALES">Inside Sales</mat-option>
                <mat-option value="OTHER">Other</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <kt-general-autocomplete
              [label]="'Manager'"
              [loadItemsFunction]="loadMembers"
              [optionFormatter]="stringUtils.displayUserName"
              [valueFormatter]="stringUtils.displayUserName"
              [required]="false"
              [change]="onOrganizerChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Manager'"
            ></kt-general-autocomplete>
          </div>
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Calls on </mat-label>
              <mat-select
                [(value)]="callsOnFilter"
                (selectionChange)="paginator.firstPage(); loadSalesTeamsList()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="DOCTOR">Doctor</mat-option>
                <mat-option value="FACILITY">Facility</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- end::FILTERS -->
    </div>
    <!-- end::FILTERS & GROUP ACTIONS -->

    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
    <div class="mat-table-wrapper" style="max-height: calc(100% - 130px)">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="created"
        matSortDirection="desc"
        matSortDisableClear
      >
        <!-- Checkbox Column -->

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Sales Team </mat-header-cell>
          <mat-cell
            *matCellDef="let salesTeam"
            (dblclick)="editSalesTeam(salesTeam)"
            class="clickable"
            [matTooltip]="!isViewMode ? 'Edit Sales Team' : ''"
            >{{ salesTeam.name }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Type </mat-header-cell>
          <mat-cell *matCellDef="let salesTeam">{{ salesTeam.type }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="manager">
          <mat-header-cell *matHeaderCellDef>Manager </mat-header-cell>
          <mat-cell *matCellDef="let salesTeam">{{
            salesTeam.manager ? salesTeam.manager.name : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="calls_on">
          <mat-header-cell *matHeaderCellDef>Calls On </mat-header-cell>
          <mat-cell *matCellDef="let salesTeam">{{ salesTeam.calls_on }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="is_active">
          <mat-header-cell *matHeaderCellDef>Status </mat-header-cell>
          <mat-cell *matCellDef="let salesTeam">
            <span
              [class]="
                'label label-lg label-inline label-light-' +
                (salesTeam.is_active ? 'success' : 'danger')
              "
            >
              {{ (salesTeam.is_active ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE') | translate }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let salesTeam">
            <button
              color="success"
              matTooltip="{{ 'TABLE.VIEW' | translate }} Target"
              (click)="viewSalesTeamTarget(salesTeam)"
              class="btn btn-icon btn-light btn-hover-success btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <span inlineSVG="./assets/media/svg/icons/General/visible.svg"></span>
              </span>
            </button>
            &nbsp;
            <button
              *ngIf="!isViewMode"
              color="warning"
              matTooltip="Activate/Deactivate Sales Team"
              (click)="updateStatusSalesTeam(salesTeam)"
              class="btn btn-icon btn-light btn-hover-warning btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-warning">
                <span inlineSVG="./assets/media/svg/icons/General/update_icon2.svg"></span>
              </span>
            </button>
            &nbsp;
            <button
              *ngIf="!isViewMode"
              color="danger"
              matTooltip="Delete Sales Team"
              (click)="deleteSalesTeam(salesTeam)"
              class="btn btn-icon btn-light btn-hover-danger btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-danger">
                <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
              </span>
            </button>
            &nbsp;
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!dataSource.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator
        [pageSize]="size"
        (page)="loadPage($event)"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
